/* eslint-disable max-len */
/* eslint-disable indent */
import React from 'react';
import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useQuery, gql } from '@apollo/client';
import { portOfDataQry } from '../gql/PortOfDataQuery';
import { qualityGroupsDataQry } from '../gql/qualityGroupsDataQuery';
import { CurrenciesQry } from '../gql/CurrenciesQry';
import { useMutation, useApolloClient } from '@apollo/client';
import { CREATE_TRANSPORTS } from '../graphqlDefs/transports/mutations';
import { getTransportRatesImporterSetting } from '../component/utils/transportRate';
import { QuantityUnitQry } from '../gql/QuantityUnitQry';
import { getMessage } from '../translations';
import { logisticMaterialsDataQry } from '../gql/logisticMaterialsDataQry';
import { GET_LOGISTIC_FORWARDER } from '../graphqlDefs/freights/mutations';

const TransportApp = () => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const handleGoBack = () => {
    navigate(-1); // Navigates back one step
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_TRANSPORT_RATE_HAROLD_WEB_URL}`, '_blank');
  }

  const [result, setResult] = useState('');
  // State to define for fetching portOfLoading names from database
  const [qualityGroupDropdownData, setQualityGroupDropdownData] = useState();
  const [currenciesAbbrDropdownData, setCurrenciesAbbrDropdownData] = useState();
  const [volumeUnitDropdownData, setVolumeUnitDropdownData] = useState();
  const [transportModeDropdownData, setTransportModeDropdownData] = useState();
  const [logisticMaterialsDropdownData, setLogisticMaterialsDropdownData] = useState([]);
  const [logisticForwardersDropdownData, setLogisticForwardersDropdownData] = useState([]);

  // Graphql query fetch port of loading & destination data
  const { data } = useQuery(portOfDataQry);
  const qualityGroupData = useQuery(qualityGroupsDataQry);
  const currenciesData = useQuery(CurrenciesQry);
  const quantityUnitData = useQuery(QuantityUnitQry);
  const logisticMaterialData = useQuery(logisticMaterialsDataQry);
  const filteredProvidersVariables = {
    filters: { type: "FORWARDER" },
    searchText: null,
  };
  const { loading: loading1, error: error1, data: data1, refetch: refetch1 } = useQuery(GET_LOGISTIC_FORWARDER, {
    variables: { input: filteredProvidersVariables },
  });
  useEffect(() => {
    refetch1();
  }, [refetch1]);
  useEffect(() => {
    if (!loading1 && data1) {
      const logisticForwNames = data1.filteredProviders.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setLogisticForwardersDropdownData(logisticForwNames);
    }
  }, [loading1, data1]);

  const fetchData = () => {

    const qualityGroupNames =
      qualityGroupData.data && qualityGroupData.data?.qualityGroups
        ? qualityGroupData.data?.qualityGroups?.map((qualityG) => ({
          label: qualityG?.value,
          alternativeMatches: [qualityG?.value],
          value: qualityG?.value,
          type: 'string',
        }))
        : '>>';

    const currenciesNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((Curren) => ({
          label: Curren?.shorthand,
          alternativeMatches: [Curren?.value],
          value: Curren?.value,
          type: 'string',
        }))
        : '>>';

    const currenciesAbbrNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((CurrenAbbr) => ({
          label: CurrenAbbr?.value,
          alternativeMatches: [CurrenAbbr?.value],
          value: CurrenAbbr?.value,
          type: 'string',
        }))
        : '>>';

    const quantityUnitNames =
      quantityUnitData.data && quantityUnitData.data?.quantityUnits
        ? quantityUnitData.data?.quantityUnits?.map((quantityUnit) => ({
          label: quantityUnit?.code,
          alternativeMatches: [quantityUnit?.code],
          value: quantityUnit?.code,
          type: 'string',
        }))
        : '>>';

    const staticTransportMode = [
      {
        label: "BARGE",
        alternativeMatches: ["BARGE"],
        value: "BARGE",
        type: "string",
      },
      {
        label: "ROAD",
        alternativeMatches: ["ROAD"],
        value: "ROAD",
        type: "string",
      },
      {
        label: "RAIL",
        alternativeMatches: ["RAIL"],
        value: "RAIL",
        type: "string",
      },
    ];

    // Update portOfLoading names to dropdown state
    setQualityGroupDropdownData(qualityGroupNames);
    setCurrenciesAbbrDropdownData(currenciesAbbrNames);
    setVolumeUnitDropdownData(quantityUnitNames);
    setTransportModeDropdownData(staticTransportMode);

  };



  function fetchFirstValidityDate(reqLastDt) {
    let retLastDt = '';
    const MAX_ALLOWED_VALUE = 10;
    if (reqLastDt !== '' && reqLastDt) {
      const inputDate = new Date(reqLastDt);
      inputDate.setDate(1);
      const firstDayOfMonth = new Date(inputDate);
      retLastDt = firstDayOfMonth.toISOString().slice(0, MAX_ALLOWED_VALUE);
    }
    return retLastDt;
  }

  const generateValidityDates = (monthNumber) => {
    const currentYear = new Date().getFullYear();
    const selectedMonth = monthNumber - 1;
    // First day of the selected month
    const firstValidityDate = new Date(currentYear, selectedMonth, 1, 5, 30, 0);
    const firstValidityDateString = `${firstValidityDate.getFullYear()}-${(firstValidityDate.getMonth() + 1).toString().padStart(2, '0')}-${firstValidityDate.getDate().toString().padStart(2, '0')}`;

    // Last day of the selected month
    const lastDay = new Date(currentYear, selectedMonth + 1, 0);
    const lastValidityDate = new Date(lastDay.getFullYear(),
      lastDay.getMonth(), lastDay.getDate(), 5, 30, 0);
    const lastValidityDateString = `${lastValidityDate.getFullYear()}-${(lastValidityDate.getMonth() + 1).toString().padStart(2, '0')}-${lastValidityDate.getDate().toString().padStart(2, '0')}`;

    return { firstValidityDate: firstValidityDateString, lastValidityDate: lastValidityDateString };
  };

  // Function to detect and extract currency code
  function extractCurrencyCode(cost) {
    // Regular expression to find the numeric part of the cost
    const costRegex = /^([\d.]+)/;

    // Regular expression to find the currency code (e.g., €, USD, GBP, etc.)
    const currencyRegex = /[€$£¥₹Є]|(USD|GBP|CAD|AUD|EUR|INR)/i;

    // Convert the cost to a string before using the regex
    const costString = cost.toString();

    // Use the regex to find the numeric part of the cost
    const costMatch = costString.match(costRegex);
    const numericCost = costMatch ? costMatch[0] : null;

    // Use the regex to find the currency code in the cost string
    const currencyMatch = costString.match(currencyRegex);
    const currencyCode = currencyMatch ? currencyMatch[0] : null;

    return { cost: numericCost, currency: currencyCode };
  }

  // Function to process the cost column and create the costCurrency column
  function extractCostAndCurrency(costColumn) {
    let retProcessColumn = '';
    const costCurrencyColumn = [];
    if (costColumn !== '' && costColumn) {
      retProcessColumn = extractCurrencyCode(costColumn);
      costCurrencyColumn.push({
        extractedArr: retProcessColumn,
      });
    }
    return costCurrencyColumn;
  }
  // We are using this function for spliting the the rows by '/' for shipping line for ex. CMA/MARESK to two diff rows
  const splitStringBySlash = (inputString) => {
    if (typeof inputString !== 'string') {
      return []; // Handle non-string input
    }

    return inputString.split('/').map((substring) => substring.trim());
  };

  useEffect(() => {
    if (data !== undefined) {
      fetchData();
    }
  }, [data]);
  useEffect(() => {
    if (logisticMaterialData.data?.logisticMaterials) {
      const logisticMaterialsNames = logisticMaterialData.data.logisticMaterials.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setLogisticMaterialsDropdownData(logisticMaterialsNames);
    }
  }, [logisticMaterialData]);

  // Below function we are calling after submission and will push to database
  async function saveTransportRate(res) {
    let flg = '';
    if (res !== '' && res.length > 0) {
      const transportValue = res.map((transport, index) => {
        return {
          comment: transport.comment === '' ? null : transport.comment,
          cost: transport.cost === '' ? null : transport.cost,
          costCurrency: transport.costCurrency === '' ? null : transport.costCurrency,
          costVolume: transport.costVolume === '' ? null : transport.costVolume,
          firstValidityDate: transport.firstValidityDate,
          lastValidityDate: transport.lastValidityDate,
          logisticForwarder:
            transport.logisticForwarder === '' ? null : transport.logisticForwarder,
          logisticMaterial:
            transport.logisticMaterial === '' ? null : transport.logisticMaterial,
          destinationArea:
            transport.destinationArea === '' ? null : transport.destinationArea,
          mode:
            transport.mode === '' ? null : transport.mode,
          qualityGroup: transport.qualityGroup === '' ? null : transport.qualityGroup,
          preCarriageArea: transport.preCarriageArea === '' ? null : transport.preCarriageArea,
          preCarriageLine: transport.preCarriageLine === '' ? null : transport.preCarriageLine,

        };
      });
      try {
        const { data, error } = await client.mutate({
          mutation: CREATE_TRANSPORTS,
          variables: { input: transportValue },
        });
        return { flg: true, message: 'Success' };

      } catch (error) {
        // console.error('Error updating post title:', error);
        return { flg: false, message: error };
      }
    }
    return flg;
  }
  const importerSettings = getTransportRatesImporterSetting({
    qualityGroupDropdownData,
    currenciesAbbrDropdownData,
    volumeUnitDropdownData,
    transportModeDropdownData,
    logisticMaterialsDropdownData,
    logisticForwardersDropdownData,
  });
  const handleImportResult = async (result, errors, complete, logs) => {
    if (errors.length === 0) {
      const rest = await saveTransportRate(result);
      if (rest.flg) {
        complete();
        setResult(result);
      } else {
        complete(new RejectSubmitResult('Error', rest.message));
        return false;
      }
    }
    else {
      complete(new RejectSubmitResult('Error', 'Please fill the required data.'));
      return false;
    }
  };

  return (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ?
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('Check out transport rates on web app')}
              </button>
              :
              <NuvoImporter
                licenseKey={licenseKey}
                settings={importerSettings}
                onResults={(result, errors, complete, logs) =>
                  handleImportResult(result, errors, complete, logs)
                }
                onEntryInit={(row, rowIndex) => {
                  // const { firstValidityDate, lastValidityDate } = generateValidityDates(validityMonth);
                  const costVolume = row.costVolume;
                  let extractedCurrency = 0;
                  let cost = 0;
                  let sheetCostVolume = row.costVolume;
                  let firstValidityDate = row.firstValidityDate;
                  let lastValidityDate = row.lastValidityDate;
                  let qualityGroup = row.qualityGroup;
                  let comment = row.comment;
                  let destinationArea = row.destinationArea;
                  let mode = row.mode;
                  let preCarriageArea = row.preCarriageArea;
                  let preCarriageLine = row.preCarriageLine;
                  let logisticForwarder = row.logisticForwarder;
                  let logisticMaterial = row.logisticMaterial;
                  if (row.cost) {
                    const [blCostCurrency] = extractCostAndCurrency(row.cost) || [];
                    if (blCostCurrency) {
                      cost = blCostCurrency.extractedArr.cost;
                      extractedCurrency = blCostCurrency.extractedArr.currency;
                    }
                  }

                  if (row.cost) {
                    return {
                      logisticForwarder: {
                        value: logisticForwarder,
                        info: [
                          {
                            message: 'Logistic forwarder',
                            level: 'info',
                          },
                        ],
                      },
                      comment: {
                        value: comment,
                        info: [
                          {
                            message: 'ABC',
                            level: 'info',
                          },
                        ],
                      },
                      mode: {
                        value: mode,
                        info: [
                          {
                            message: 'RAIL',
                            level: 'info',
                          },
                        ],
                      },
                      destinationArea: {
                        value: destinationArea,
                        info: [
                          {
                            message: 'Coimbatore',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageLine: {
                        value: preCarriageLine,
                        info: [
                          {
                            message: 'JJB',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageArea: {
                        value: preCarriageArea,
                        info: [
                          {
                            message: 'Boston',
                            level: 'info',
                          },
                        ],
                      },
                      logisticMaterial: {
                        value: logisticMaterial,
                        info: [
                          {
                            message: 'Cost to 40HC',
                            level: 'info',
                          },
                        ],
                      },
                      qualityGroup: {
                        value: qualityGroup,
                        info: [
                          {
                            message: 'Quality group',
                            level: 'info',
                          },
                        ],
                      },
                      firstValidityDate: {
                        value: firstValidityDate,
                        info: [
                          {
                            message: 'First validity date',
                            level: 'info',
                          },
                        ],
                      },
                      lastValidityDate: {
                        value: lastValidityDate,
                        info: [
                          {
                            message: 'Last validity date',
                            level: 'info',
                          },
                        ],
                      },
                      cost: {
                        value: cost,
                        info: [
                          {
                            message: 'Cost',
                            level: 'info',
                          },
                        ],
                      },
                      costVolume: {
                        value: sheetCostVolume === '' || sheetCostVolume === undefined ? 'Ctn' : sheetCostVolume,
                        info: [
                          {
                            message: 'CTC',
                            level: 'info',
                          },
                        ],
                      },
                      costCurrency: {
                        value: extractedCurrency,
                        info: [
                          {
                            message: 'Cost currency',
                            level: 'info',
                          },
                        ],
                      },

                    };
                  }
                }}

              >
                {getMessage('Import transport rate')}
              </NuvoImporter>
            }
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          {result !== '' ?
            <div className='white-box'>
              {Object.keys(result).length !== 0 && (
                <pre>
                  {typeof result === 'string'
                    ? result
                    : JSON.stringify(result, null, 2)}
                </pre>
              )}
            </div>
            :
            <></>
          }
        </div>
      </div>
    </div>
  );
};
export default TransportApp;
